import { createAsyncThunk } from "@reduxjs/toolkit";
import { WarehouseAxios } from "api/WarehouseAxios";
import { API_ENDPOINT } from "helpers/Endpoints/endpoints";
import { FilterBuilder } from "helpers/ThunkHelper/FilterBuilder";

export const fetchDailyLogs = createAsyncThunk(
  "dailyLogs/fetchDailyLogs",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
    warehouse_id
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
    warehouse_id?: any;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }

    const filterPayload = FilterBuilder(filters ?? []);
    const body = {
      filters: filterPayload,
    };
    const response: any = await WarehouseAxios.post(
      `${API_ENDPOINT.WAREHOUSE.STOCK_OVERVIEW.DAILY_LOG.LIST(warehouse_id)}&${params.toString()}`,
      body
    );

    // console.log("daily log => ",response);

    return {
      data: response?.data?.data || [],
      rowCount: response.data.count || 0,
    };
  }
);

export const fetchDailyLogDropDown = createAsyncThunk(
  "dailyLog/fetchDailyLogDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await WarehouseAxios.get(
        API_ENDPOINT.WAREHOUSE.STOCK_OVERVIEW.DAILY_LOG.DROPDOWN
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch daily log dropdown data"
      );
    }
  }
);

export const exportDailyLogCSV = async ({
  warehouse_id,
  search,
  filters,
}: {
  warehouse_id: string;
  search?: string;
  filters?: {
    filterField: string;
    filterValue: any;
  }[];
}) => {
  const params = new URLSearchParams();

  if (search) params.append("search", search);

  const filterPayload = FilterBuilder(filters ?? []);

  const body = {
    filters: filterPayload,
  };

  const response = await WarehouseAxios.post(
    `${API_ENDPOINT.WAREHOUSE.STOCK_OVERVIEW.DAILY_LOG.EXPORT(warehouse_id)}&${params.toString()}`,
    body,
    { responseType: "blob" }
  );

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") ||
      `daily_log_${new Date().toISOString().split("T")[0]}.csv`,
  };
};
